import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const saveReturnView = {
  name: "saveReturnView" as const,
  input: z.object({ view: viewSchemas.returns, type: z.enum(ReturnTypeEnum) }),
  output: z.object({}),
};
